import React, {useEffect, useState} from 'react'
import Header from "../../../layout/header";
import BottomMenu from "../../../layout/bottomMenu";
import "../../../Dashboard/Dashboard.css";
import "../../../Dashboard/Sidebar.js";
import useLatLng from "../../../../hooks/uselatlng/uselatlng";
import SuccessModal from "../../../CustomModal/Success";
import FailedModal from "../../../CustomModal/Failed";
import Loader from "../../../../Loader/Loader";
import DashboardMenu from "../../../layout/dashboardMenu";
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import SearchLocation from "../../../searchLocation/searchLocation";

toast.configure()

const CarServiceAccount = ({
                               locationPinCode,
                               pincodeData,
                               locationCity,
                               locationZone,
                               locationArea,
                               cities = [],
                               zones = [],
                               areas = [],
                               saveAccount,
                               saveDetails = [],
                               accountDetailsByIdData = [],
                               match,
                               history,
                               accountById,
                               sitePocTypes,
                               pocTypes=[],
                               oemManufactureName,
                               eomName=[]
                           }) => {

    let validRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/
    const [pocDetails, addPOCDetails] = useState([{
        name: '',
        designation_type_id: '',
        email: '',
        number: '',
        company_name: '',
        Designation_Other:'',
    }])
    const [inputList, setInputList] = useState([{
        client_name: '',
        address_1: '',
        address_2: '',
        client_lat: '',
        client_long: '',
        project_type: '',
        pincode: '',
        area_id: '',
        latitude: '',
        longitude: '',
        oem_manufacturer_name:''
    }]);

    const [isLoading, setIsLoading] = useState(false)
    const [isSuccessModalOpen, setIsSuccessModalOpen] = React.useState(false);
    const [isFailedModalOpen, setIsFailedModalOpen] = React.useState(false);
    const [countToOpenModal, setCountToOpenModal] = useState(0)
    const [oemManufactureNames, setOemManufactureName] = useState('')

    const [pincode, setPincode] = useState([]);
    const [mapLocation, setMapLocation] = useState({
        address: 'Delhi',
        lat: 0,
        lng: 0,
    });
    const islatlng = useLatLng();
    const [isAllow, setIsAllow] = useState(false);
    const [isEdit, setIsEdit] = useState(false)
    const [userMessage, setUserMessage] = useState('')
    const [redirectUrl, setRedirectUrl] = useState('')
    const [isView, setIsView] = useState(false)
    const [userId, setUserId] = useState('')
    const [roleId, setRoleId] = useState("")
    const [optOption, setOptOption] = useState({
        address2: '',
        currentLocation: '',
    });
    const [lat, setLat] = useState('')
    const [long, setLong] = useState('')
    const [pincodeValue, setPincodeValue] = useState('')
    const [cityId, setCityId] = useState(0)
    const [zoneId, setZoneId] = useState(0)
    const [areaId, setAreaId] = useState(0)

    useEffect(() => {
        let roleId = localStorage.getItem('role_id')
        setRoleId(roleId)
    }, [])

    useEffect(() => {
        (async () => {
            setIsView(false)
            var split = document.URL.split("/");
            if (localStorage.getItem('userId') !== undefined) {
                setUserId(localStorage.getItem('user_id'))
            }

            if (split.includes('view-account')) {
                setIsView(true)
            }
            setIsLoading(true)
            await locationCity()
            await sitePocTypes()
            await oemManufactureName()
            if (match?.params?.id !== undefined) {
                await accountById(match?.params?.id)
                setIsEdit(true)
            }
            setIsLoading(false)
        })()
    }, [])


    const handleInput = (val, index) => {
        const list = [...inputList]
        list[0][index] = val
        setInputList(list)
    }

    const handlePocInput = (val, index, i) => {
        const list = [...pocDetails]
        list[i][index] = val
        addPOCDetails(list)
    }

    const getCityStateByPincode = async (pincode) => {
        if (pincode === '') {
            return false
        }
        await locationPinCode(pincode)
    }

    useEffect(() => {
        setPincode([])
        setTimeout(() => {
            setIsLoading(true)
            if (pincodeData && pincodeData.length > 0) {
                setPincode(pincodeData[0])
            }
            setIsLoading(false)
        }, 1000)
    }, [pincodeData])

    const handleAddPOC = () => {
        // const list = [...pocDetails]
        addPOCDetails([
            ...pocDetails,
            {
                name: '',
                city: '',
                designation: '',
                email: '',
                number: '',
                designation_type_id: '',
                Designation_Other:''
            }
        ])
    }

    useEffect(() => {
        if (islatlng === false) {
            setIsAllow(true);
        } else {
            setIsAllow(false);
        }
        var lati = Number(islatlng?.lat);
        var langi = Number(islatlng?.lng);
        if (!isNaN(lati) && !isNaN(langi)) {
            setMapLocation({
                address: 'Delhi6',
                lat: Number(islatlng?.lat),
                lng: Number(islatlng?.lng),
            });
        }
    }, [islatlng]);

    useEffect(() => {
        setIsFailedModalOpen(false)
        setIsSuccessModalOpen(false)
        if (parseInt(saveDetails?.status) === 200) {
            setCountToOpenModal(countToOpenModal + 1)
            setIsSuccessModalOpen(true)
            setUserMessage(saveDetails?.message)
            setRedirectUrl('car-service-account-list')
        } else if (saveDetails?.status !== undefined && saveDetails?.status !== 200) {
            setCountToOpenModal(countToOpenModal + 1)
            setIsFailedModalOpen(true)
            setUserMessage(saveDetails?.message)
        }
    }, [saveDetails])

    // useEffect(() => {
    //     setIsFailedModalOpen(false)
    //     setIsSuccessModalOpen(false)
    //     if (parseInt(updateAccountDetails?.status) === 200) {
    //         setCountToOpenModal(countToOpenModal + 1)
    //         setIsSuccessModalOpen(true)
    //         setUserMessage(updateAccountDetails?.message)
    //         if (match?.params?.lead_id !== undefined) {
    //             setRedirectUrl('list-account/' + match?.params?.lead_id)
    //         } else {
    //             setRedirectUrl('list-account')
    //         }
    //     } else if (updateAccountDetails?.status !== undefined && updateAccountDetails?.status !== 200) {
    //         setCountToOpenModal(countToOpenModal + 1)
    //         setIsFailedModalOpen(true)
    //         setUserMessage(updateAccountDetails?.message)
    //     }
    // }, [updateAccountDetails])

    const handleRemovePOC = (e, index) => {
        const list = [...pocDetails]
        list.splice(index, 1);
        addPOCDetails(list);
        e.preventDefault()
    }

    const [projectTypeId, setProjectTypeId] = useState('')

    useEffect(() => {
        if (match?.params?.id !== undefined) {
            (async () => {
                setIsLoading(true)
                await accountById(match?.params?.id)
                setIsLoading(false)
            })()
        }
    }, [match.params.id])

    useEffect(() => {
        if (accountDetailsByIdData !== [] && accountDetailsByIdData?.account_type_id !== undefined) {
            (async () => {
                await locationPinCode(accountDetailsByIdData?.pincode)
            })()
            setIsEdit(true)
            setProjectTypeId(accountDetailsByIdData?.project_type)
            if (accountDetailsByIdData?.poc_details !== [] && accountDetailsByIdData?.poc_details.length > 0) {
                addPOCDetails(accountDetailsByIdData?.poc_details)
            }

            var split = document.URL.split("/");
            if (split.includes('edit-account') && parseInt(accountDetailsByIdData?.stage) === 11) {
                toast.error("You can't update account details now")
                window.location.href = "view-account/" + match?.params?.id
            }
            // if(parseInt(accountDetailsByIdData?.is_draft) === 1){
            //     setIsView(false)
            // }
        }
    }, [accountDetailsByIdData])


    useEffect(() => {
        if (accountDetailsByIdData?.data !== undefined) {
            handleInput(accountDetailsByIdData?.data?.client_name, 'client_name')
            handleInput(accountDetailsByIdData?.data?.solution_type, 'solution_type')
            handleInput(accountDetailsByIdData?.data?.latitude, 'latitude')
            handleInput(accountDetailsByIdData?.data?.longitude, 'longitude')
            handleInput(accountDetailsByIdData?.data?.pincode, 'pincode')
            handleInput(accountDetailsByIdData?.data?.address_1, 'address_1')
            setCityId(accountDetailsByIdData?.data?.city_id)
            setAreaId(accountDetailsByIdData?.data?.area_id)
            setZoneId(accountDetailsByIdData?.data?.zone_id)
            handleInput(accountDetailsByIdData?.data?.geographical_city_id, 'geographical_city_id')
            handleInput(accountDetailsByIdData?.data?.geographical_state_id, 'geographical_state_id')
            handleInput(accountDetailsByIdData?.data?.oem_manufacturer_name, 'oem_manufacturer_name')
            setOemManufactureName(accountDetailsByIdData?.data?.oem_manufacturer_name)
            setLat(accountDetailsByIdData?.data?.latitude)
            setLong(accountDetailsByIdData?.data?.longitude)
            setPincodeValue(accountDetailsByIdData?.data?.pincode)
            setOptOption({...optOption, currentLocation: accountDetailsByIdData?.data?.current_location});
            addPOCDetails(accountDetailsByIdData?.data?.poc_details)
        }
    }, [accountDetailsByIdData])

    useEffect(() => {
        getCityStateByPincode(pincodeValue)
    }, [pincodeValue])

    const handleSubmit = async (e) => {
        e.preventDefault()
        let requestParams = inputList[0]

        let isEmailValid = true
        let msg = ''
        pocDetails.map((val, i) => {
            if (!val?.email.match(validRegex)) {
                msg = "Enter valid email for " + val.name
                isEmailValid = false
            }

            if(val?.company_name === '' || val?.company_name === null){
                pocDetails[i]["company_name"] = requestParams['client_name']
            }
        })

        if (!isEmailValid) {
            toast.error(msg)
            return false
        }

        if (requestParams['client_name'] === '') {
            toast.error('Service Center name is required')
            return false
        }


        requestParams['poc_details'] = pocDetails
        requestParams['geographical_state_id'] = pincode?.geo_state_id
        requestParams['geographical_city_id'] = pincode?.geo_city_id
        requestParams['pincode'] = pincode?.pincode
        requestParams['area_id'] = areaId
        requestParams['client_lat'] = islatlng?.lat
        requestParams['client_long'] = islatlng?.lng
        requestParams['is_draft'] = false
        requestParams['area_id'] = areaId
        requestParams['city_id'] = cityId
        requestParams['zone_id'] = zoneId
        requestParams['project_type'] = 16

        // console.log("requestParamsrequestParams "+JSON.stringify(requestParams))
        // return false
        if (requestParams['latitude'] == null || requestParams['longitude'] == null || requestParams['client_lat'] == null || requestParams['client_long'] == null) {
            toast.error('Please enable your location');
            return false
        }

        // return false
        setIsLoading(true)
        if (isEdit) {
            requestParams['id'] = match?.params.id
        }
        await saveAccount(requestParams)
        setIsLoading(false)
    }


    const handleDraft = async (e) => {
        e.preventDefault()
        let requestParams = inputList[0]

        if (requestParams['client_name'] === '') {
            toast.error('Service Center name is required')
            return false
        }


        requestParams['is_draft'] = true
        requestParams['poc_details'] = pocDetails
        requestParams['geographical_state_id'] = pincode?.geo_state_id
        requestParams['geographical_city_id'] = pincode?.geo_city_id
        requestParams['pincode'] = pincode?.pincode
        requestParams['client_lat'] = mapLocation?.lat
        requestParams['client_long'] = mapLocation?.lng
        requestParams['area_id'] = areaId
        requestParams['city_id'] = cityId
        requestParams['zone_id'] = zoneId
        requestParams['project_type'] = 16

        if (requestParams['client_lat'] == null || requestParams['client_long'] == null) {
            toast.error('Please enable your location');
            return false
        }

        setIsLoading(true)
        if (isEdit) {
            requestParams['id'] = match?.params.id
        }
        // console.log("requestParams "+JSON.stringify(requestParams) )
        await saveAccount(requestParams)
        setIsLoading(false)
    }

    const handleCurrentLocationBlur = (latlng = null) => {
        if (latlng !== null && latlng !== undefined) {
            setLong(latlng?.lng)
            setLat(latlng?.lat)
            handleInput(latlng?.lng, 'longitude')
            handleInput(latlng?.lat, 'latitude')
        }
    };

    const handleCurrentLocationChange = (value) => {
        setOptOption({...optOption, currentLocation: value});
        handleInput(value, 'current_location')
        handleInput(value, 'address_1')
    };

    useEffect(() => {
        (async () => {
            handleInput(cityId, 'city_id')
            await locationZone(cityId !== 0 ? cityId : accountDetailsByIdData?.data?.city_id)
        })()
    }, [cityId, accountDetailsByIdData])

    useEffect(() => {
        (async () => {
            handleInput(zoneId, 'zone_id')
            await locationArea(zoneId !== 0 ? zoneId : accountDetailsByIdData?.data?.zone_id)
        })()
    }, [zoneId, accountDetailsByIdData])

    return (
        <>
            <SuccessModal
                isOpen={isSuccessModalOpen}
                msg={userMessage}
                url={redirectUrl}
            />


            <FailedModal
                isOpen={isFailedModalOpen}
                msg={userMessage}
                countToOpenModal={countToOpenModal}
            />
            <Loader isLoading={isLoading}/>
            <div id="wrapper">
                <DashboardMenu/>
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header
                            title={'Service Center'}
                            history={history}
                        />
                        {/*BODY*/}
                        <div>
                            <div className="container-fluid">
                                {/*Heading*/}
                                <div className="hide d-sm-flex align-items-center justify-content-between com-heading">
                                    <h1 className="h3 mb-0 text-black-100">Add Account</h1>
                                </div>
                                <form onSubmit={(e) => handleSubmit(e)}>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div
                                                className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                                                <h1 className="h3 mb-0 text-black-100">Details</h1>
                                            </div>
                                            <div className="card-body bg-white">
                                                <div className="user">
                                                    <div className="form-group row">
                                                        <div className="col-md-6 float-field ">
                                                            <input type="text"
                                                                   className="form-control form-control-user"
                                                                   placeholder=" "
                                                                   onChange={(e) => {
                                                                       handleInput(e.target.value, 'client_name')
                                                                   }}
                                                                   required
                                                                   value={inputList[0]?.client_name}
                                                                   disabled={isView}
                                                            />

                                                            <label className="large-label float-lb">
                                                                Name <i
                                                                className="bi bi-asterisk astrick-icon"></i>
                                                            </label>
                                                        </div>

                                                        <div className="col-md-6 float-field">
                                                            <select className="form-control"
                                                                    onChange={(e) => {
                                                                        handleInput(e.target.value, 'oem_manufacturer_name')
                                                                    }} required>
                                                                <option value="">Select OEM Manufacturer Name</option>
                                                            {eomName !== [] &&
                                                                eomName.map((value, i) => {
                                                                    return (
                                                                        <>
                                                                            {parseInt(value?.id) === parseInt(oemManufactureNames) ?
                                                                                <option value={`${value?.id}`} selected>{value?.name}
                                                                                </option>  :
                                                                                <option value={`${value?.id}`}>{value?.name}
                                                                                </option>
                                                                            }
                                                                        </>
                                                                    )
                                                                })}
                                                            </select>
                                                            <label className="large-label float-lb">
                                                                OEM Manufacturer Name
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div
                                                className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                                                <h1 className="h3 mb-0 text-black-100">Location</h1>
                                            </div>
                                            <div className="card-body  bg-white">
                                                <div className="user">
                                                    <div className="form-group row">
                                                        <SearchLocation
                                                            handleCurrentLocationBlur={handleCurrentLocationBlur}
                                                            value={optOption.currentLocation}
                                                            handleCurrentLocationChange={handleCurrentLocationChange}
                                                            isView={isView}
                                                            setPincodeValue={setPincodeValue}
                                                        />
                                                        <div className="col-md-6 float-field">
                                                            <input type="text"
                                                                   className="form-control form-control-user"
                                                                   placeholder=" "
                                                                   onChange={(val) => {
                                                                       handleInput(val, 'latitude')
                                                                   }}
                                                                   value={lat}
                                                            />

                                                            <label className="large-label float-lb">
                                                                Latitude <i className="bi bi-asterisk astrick-icon"></i>
                                                            </label>
                                                        </div>
                                                        <div className="col-md-6 float-field">
                                                            <input type="text"
                                                                   className="form-control form-control-user"
                                                                   placeholder=" "
                                                                   onChange={(val) => {
                                                                       handleInput(val, 'longitude')
                                                                   }}
                                                                   value={long}
                                                                   disabled={isView}
                                                            />

                                                            <label className="large-label float-lb">
                                                                Longitude <i
                                                                className="bi bi-asterisk astrick-icon"></i>
                                                            </label>
                                                        </div>
                                                        <div className="col-md-6 float-field d-mtk-1">
                                                            <input type="text"
                                                                   className="form-control form-control-user"
                                                                   placeholder=" "
                                                                   onChange={(e) => {
                                                                       handleInput(e.target.value, 'address_1')
                                                                   }}
                                                                   required
                                                                   value={inputList[0].address_1}
                                                                   disabled={isView}
                                                            />

                                                            <label className="large-label float-lb">
                                                                Address of site 1 <i
                                                                className="bi bi-asterisk astrick-icon"></i>
                                                            </label>
                                                        </div>
                                                        <div className="col-md-6 float-field">
                                                            <input type="text"
                                                                   className="form-control form-control-user"
                                                                   placeholder=" "
                                                                   onChange={(e) => {
                                                                       setPincodeValue(e.target.value, 'pincode')
                                                                   }}
                                                                   value={pincodeValue}
                                                                   required
                                                                   disabled={isView}
                                                            />

                                                            <label className="large-label float-lb">
                                                                Pincode <i className="bi bi-asterisk astrick-icon"></i>
                                                            </label>
                                                        </div>
                                                        <div className="col-md-6 float-field">
                                                            <input type="text"
                                                                   className="form-control form-control-user"
                                                                   placeholder=" "
                                                                   onChange={(e) => {
                                                                       handleInput(pincode?.geo_city_id, 'geographical_city_id')
                                                                   }}
                                                                   disabled
                                                                   value={pincode?.city_name !== undefined ? pincode?.city_name : ''}
                                                                   required
                                                            />

                                                            <label className="large-label float-lb">
                                                                Geographical City <i
                                                                className="bi bi-asterisk astrick-icon"></i>
                                                            </label>
                                                        </div>
                                                        <div className="col-md-6 float-field">
                                                            <input type="text"
                                                                   className="form-control form-control-user"
                                                                   placeholder=" "
                                                                   onChange={(e) => {
                                                                       handleInput(pincode?.geo_state_id, 'geographical_state_id')
                                                                   }}
                                                                   disabled
                                                                   value={pincode?.state_name !== undefined ? pincode?.state_name : ''}
                                                                   required
                                                            />

                                                            <label className="large-label float-lb">
                                                                Geographical State <i
                                                                className="bi bi-asterisk astrick-icon"></i>
                                                            </label>
                                                        </div>
                                                        <div className="col-md-6 float-field mt-1">
                                                            <select className="form-control form-control-user"
                                                                    onChange={(e) => setCityId(e.target.value)}
                                                                    disabled={isView}
                                                                    style={isView ? {backgroundImage: "none"} : {}}
                                                                    required>
                                                                <option value="">Select City</option>
                                                                {cities.map((val) => {
                                                                    return (
                                                                        <>
                                                                            {(parseInt(accountDetailsByIdData?.data?.city_id) === val?.id) ?
                                                                                <>
                                                                                    return (
                                                                                    <option value={val?.id}
                                                                                            selected>{val.name}</option>
                                                                                    )
                                                                                </> :
                                                                                <option
                                                                                    value={val?.id}>{val.name}</option>
                                                                            }
                                                                        </>
                                                                    )
                                                                })}
                                                                required
                                                            </select>

                                                            <label className="large-label float-lb">
                                                                City <i className="bi bi-asterisk astrick-icon"></i>
                                                            </label>
                                                        </div>
                                                        <div className="col-md-6 float-field mtk-1 d-mtk-033">
                                                            <select className="form-control form-control-user"
                                                                    onChange={(e) => setZoneId(e.target.value)}
                                                                    disabled={isView}
                                                                    style={isView ? {backgroundImage: "none"} : {}}
                                                                    required>
                                                                <option value="">Select Zone</option>
                                                                {zones.map((val) => {
                                                                    return (
                                                                        <>
                                                                            {(parseInt(accountDetailsByIdData?.data?.zone_id) === val?.id) ?
                                                                                <>
                                                                                    return (
                                                                                    <option value={val?.id}
                                                                                            selected>{val.name}</option>
                                                                                    )
                                                                                </> :
                                                                                <option
                                                                                    value={val?.id}>{val.name}</option>
                                                                            }
                                                                        </>
                                                                    )
                                                                })}
                                                                required
                                                            </select>

                                                            <label className="large-label float-lb">
                                                                Zone <i className="bi bi-asterisk astrick-icon"></i>
                                                            </label>
                                                        </div>
                                                        <div className="col-md-6 float-field mtk-2 d-mtk-1">
                                                            <select className="form-control form-control-user"
                                                                    onChange={(e) => setAreaId(e.target.value)}
                                                                    disabled={isView}
                                                                    style={isView ? {backgroundImage: "none"} : {}}
                                                                    required>
                                                                <option value="">Select Area/Sector</option>
                                                                {areas.map((val) => {
                                                                    return (
                                                                        <>
                                                                            {(parseInt(accountDetailsByIdData?.data?.area_id) === val?.id) ?
                                                                                <>
                                                                                    return (
                                                                                    <option value={val?.id}
                                                                                            selected>{val.name}</option>
                                                                                    )
                                                                                </> :
                                                                                <option
                                                                                    value={val?.id}>{val.name}</option>
                                                                            }
                                                                        </>
                                                                    )
                                                                })}
                                                                required
                                                            </select>

                                                            <label className="large-label float-lb">
                                                                Area/Sector <i
                                                                className="bi bi-asterisk astrick-icon"></i>
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div
                                                className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                                                <h1 className="h3 mb-0 text-black-100">POC Details</h1>
                                            </div>
                                            <div className="mb-4 bg-white"> {/*card*/}
                                                <div className="hide card-header bg-lightGreen-active">
                                                    POC Details
                                                </div>
                                                <div className="card-body">
                                                    <div className="user">
                                                        <div className="form-group row">
                                                            {pocDetails.map((val, i) => {
                                                                return (
                                                                    <>
                                                                        {/*<div className="col-sm-12" id={i + 1}>*/}
                                                                        <div
                                                                            className="col-sm-6 col-md-3 mt-1 float-field">
                                                                            <input type="text"
                                                                                   className="form-control form-control-user"
                                                                                   placeholder=" "
                                                                                   onChange={(e) => {
                                                                                       handlePocInput(e.target.value, 'name', i)
                                                                                   }}
                                                                                   required
                                                                                   value={val?.name}
                                                                                   disabled={isView}
                                                                            />
                                                                            <label
                                                                                className="large-label float-lb">
                                                                                Name <i
                                                                                className="bi bi-asterisk astrick-icon"></i>
                                                                            </label>
                                                                        </div>
                                                                        <div
                                                                            className="col-sm-6 col-md-3 mt-1 float-field">
                                                                            <input type="text"
                                                                                   className="form-control form-control-user"
                                                                                   placeholder=" "
                                                                                   onChange={(e) => {
                                                                                       handlePocInput(e.target.value, 'company_name', i)
                                                                                   }}
                                                                                   required
                                                                                   value={(val?.company_name === '' || val?.company_name === null) ? inputList[0]?.client_name : val?.company_name}
                                                                                   disabled={isView}
                                                                            />
                                                                            <label
                                                                                className="large-label float-lb">
                                                                                Company Name <i
                                                                                className="bi bi-asterisk astrick-icon"></i>
                                                                            </label>
                                                                        </div>
                                                                        {/* <div className="col-sm-6 col-md-3 mt-1 float-field"> */}
                                                                        <div className="col-md-6 float-field mt-sel">
                                                                            <select className="form-control"
                                                                                    onChange={(e) => {
                                                                                        handlePocInput(e.target.value, 'designation_type_id', i)
                                                                                    }} required>
                                                                                <option value="">Select Designation Name
                                                                                </option>
                                                                                {pocTypes !== [] &&
                                                                                pocTypes.map((value, i) => {
                                                                                    return (
                                                                                        <>
                                                                                            {parseInt(value?.id) === parseInt(val?.designation_type_id) ?
                                                                                                <option value={`${value?.id}`} selected>{value?.name}
                                                                                                </option>  :
                                                                                                <option value={`${value?.id}`}>{value?.name}
                                                                                                </option>
                                                                                            }
                                                                                        </>
                                                                                    )
                                                                                })}
                                                                            </select>
                                                                        </div>

                                                                        {parseInt(val?.designation_type_id) === 9 &&
                                                                            <div
                                                                                className="col-sm-6 col-md-3 float-field d-mtk-1">
                                                                                <input type="text"
                                                                                       className="form-control form-control-user"
                                                                                       placeholder=" "
                                                                                       onChange={(e) => {
                                                                                           handlePocInput(e.target.value, 'Designation_Other', i)
                                                                                       }}
                                                                                       required
                                                                                       value={val?.Designation_Other}
                                                                                       disabled={isView}
                                                                                />
                                                                                <label
                                                                                    className="large-label float-lb">
                                                                                    Designation Other <i
                                                                                    className="bi bi-asterisk astrick-icon"></i>
                                                                                </label>
                                                                            </div>
                                                                        }
                                                                        {/* </div> */}
                                                                        <div
                                                                            className="col-sm-6 col-md-3 float-field d-mtk-1">
                                                                            <input type="email"
                                                                                   className="form-control form-control-user"
                                                                                   placeholder=" "
                                                                                   onChange={(e) => {
                                                                                       handlePocInput(e.target.value, 'email', i)
                                                                                   }}
                                                                                   required
                                                                                   value={val?.email}
                                                                                   disabled={isView}
                                                                            />
                                                                            <label
                                                                                className="large-label float-lb">
                                                                                Email Id <i
                                                                                className="bi bi-asterisk astrick-icon"></i>
                                                                            </label>
                                                                        </div>
                                                                        <div
                                                                            className="col-sm-6 col-md-3 mt-1 float-field">

                                                                            <input type="number"
                                                                                   className="form-control form-control-user"
                                                                                   placeholder=" "
                                                                                   onChange={(e) => {
                                                                                       handlePocInput(e.target.value, 'number', i)
                                                                                   }}
                                                                                   required
                                                                                   value={val?.number}
                                                                                   disabled={isView}
                                                                            />
                                                                            <label
                                                                                className="large-label float-lb">
                                                                                Mobile Number <i
                                                                                className="bi bi-asterisk astrick-icon"></i>
                                                                            </label>
                                                                        </div>
                                                                        {!isView &&
                                                                            <div className="btn-box mb-4"
                                                                                 style={{"width": "100%"}}>
                                                                                {pocDetails.length !== 1 &&
                                                                                    <>
                                                                                        <button
                                                                                            onClick={(e) => handleRemovePOC(e, i)}
                                                                                            className="btn btn-sm btn-danger ml-3 btn-ar">Remove
                                                                                        </button>
                                                                                    </>
                                                                                }
                                                                                {pocDetails.length - 1 === i &&
                                                                                    <button
                                                                                        className="btn btn-sm btn-primary ml-3 btn-ar"
                                                                                        onClick={() => handleAddPOC()}>Add
                                                                                    </button>}
                                                                            </div>
                                                                        }
                                                                        {/*</div>*/}
                                                                    </>
                                                                )
                                                            })}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="d-flex">
                                        <>
                                            <div className="col-sm-12 mb-4">
                                                <button className="btn btn-primary btn-user btn-block submit-btn">
                                                    {isEdit ? "Update" : 'Submit'}
                                                </button>
                                            </div>
                                            {!isEdit || (accountDetailsByIdData?.data?.is_draft !== undefined && parseInt(accountDetailsByIdData?.data?.is_draft) === 1) ?
                                                <>
                                                    <div className="col-sm-6">
                                                        <a href="#" className="draft-float"
                                                           onClick={(e) => handleDraft(e)}>
                                                            <p className="my-float">Draft</p>
                                                        </a>
                                                    </div>
                                                </>
                                                : ''
                                            }
                                        </>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <BottomMenu/>
            </div>
        </>
    )
}

export default CarServiceAccount